import React from "react";
import { Checkbox } from "../../atoms/Checkbox";
import { ItemLogo } from "./ItemLogo";
import { Cell, Grid, Name, Note, ShowAll, Tile } from "./SelectionGrid.styles";
import type { SelectionGridProps } from "./SelectionGrid.types";

/** A 3-column grid of values (logo or initials, name, included state); a first page, then a "show all" cell. */
export const SelectionGrid: React.FC<SelectionGridProps> = ({
  items,
  onToggle,
  pageSize = 5,
  expanded = false,
  onShowAll,
  showAllLabel,
  ariaLabel,
  className,
}) => {
  const hidden = !expanded && items.length > pageSize;
  const shown = hidden ? items.slice(0, pageSize) : items;
  return (
    <Grid className={className} aria-label={ariaLabel} data-testid="selection-grid">
      {shown.map((item) => (
        <Cell key={item.id}>
          <Tile $off={!!item.disabled}>
            <Checkbox
              checked={item.selected}
              disabled={item.disabled}
              ariaLabel={item.label}
              onChange={() => onToggle(item.id)}
            />
            <ItemLogo label={item.label} logoSrc={item.logoSrc} initials={item.initials} accent={item.accent} />
            <Name>{item.label}</Name>
            {item.note && <Note>{item.note}</Note>}
          </Tile>
        </Cell>
      ))}
      {hidden && (
        <Cell>
          <ShowAll type="button" $off={false} onClick={onShowAll}>
            {showAllLabel}
          </ShowAll>
        </Cell>
      )}
    </Grid>
  );
};

export default SelectionGrid;
